import React, { ReactElement } from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";

interface Props {
  stat: number;
  title?: string;
  icon?: string;
  iconBg?: string;
  label?: string;
}

export default function StatCard({
  title,
  stat,
  icon,
  iconBg,
  label,
}: Props): ReactElement {
  return (
    <Card className="card-stats mb-4 mb-xl-0 shadow-sm">
      <CardBody>
        <Row>
          <div className="col">
            <span className="h2 font-weight-bold mb-0">{stat}</span>
            {title && (
              <CardTitle tag="h5" className="text-uppercase  mb-0">
                {title}
              </CardTitle>
            )}
          </div>
          {icon && (
            <Col className="col-auto">
              <div
                className={"icon icon-shape rounded-circle shadow"}
                style={{ backgroundColor: iconBg }}
              >
                <i className={icon} />
              </div>
            </Col>
          )}
        </Row>
        <span className="mb-0 text-muted small">{label}</span>
      </CardBody>
    </Card>
  );
}
